import { listCargaTrabalhoProfissionais } from "@/modules/carga-trabalho/carga-trabalho.gateway";
import type {
  CargaTrabalhoPeriodo,
  CargaTrabalhoProfissional,
} from "@/modules/carga-trabalho/carga-trabalho.types";

export const VERIFICACAO_ERROR_MESSAGE =
  "Não foi possível verificar a disponibilidade do profissional.";

/** Alocações e indisponibilidades dos profissionais no período da obra (carga de trabalho, HU 1779). */
export async function carregarAlocacoesDoPeriodo(
  periodo: CargaTrabalhoPeriodo,
  profissionalIds: string[],
  signal?: AbortSignal,
): Promise<CargaTrabalhoProfissional[]> {
  const data = await listCargaTrabalhoProfissionais({ periodo, profissionalIds, signal });
  return data.profissionais;
}
